var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { hideBackdrop, showBackdrop } from "@js/common/design";
import { translate } from "@js/common/helpers";
import { StarList } from "../rating/components/common/StarList";
import { GlobalModalModes, Statuses } from "../rating/enums";
import { Textarea } from "../rating/components/common/Textarea";
var GlobalModal = function (_a) {
    var _b;
    var mode = _a.mode, rating = _a.rating, afterRatingUpdate = _a.afterRatingUpdate, afterRatingDelete = _a.afterRatingDelete, afterClose = _a.afterClose, isCommentPresent = _a.isCommentPresent;
    var _c = useState(true), isOpen = _c[0], setIsOpen = _c[1];
    var _d = useState(rating || { note: 0, comment: '', status: Statuses.Enabled }), ratingState = _d[0], setRatingState = _d[1];
    var modalRef = useRef(null);
    useEffect(function () {
        if (isOpen === false) {
            hideBackdrop();
            if (typeof afterClose === 'function') {
                afterClose();
            }
            return;
        }
        showBackdrop();
        var handleClickOutside = function (event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);
    var handleClose = function (event) {
        event.stopPropagation();
        setIsOpen(false);
    };
    var handleUpdate = function (event) {
        event.stopPropagation();
        if (typeof afterRatingUpdate === 'function') {
            afterRatingUpdate(ratingState);
        }
        setIsOpen(!isOpen);
    };
    var handleDelete = function (event) {
        event.stopPropagation();
        if (typeof afterRatingDelete === 'function') {
            afterRatingDelete();
        }
        setIsOpen(!isOpen);
    };
    var handleStarNumberChange = function (note) {
        setRatingState(function (prevState) { return (__assign(__assign({}, prevState), { note: note })); });
    };
    var handleCommentChange = function (comment) {
        setRatingState(function (prevState) { return (__assign(__assign({}, prevState), { comment: comment, status: comment.trim().length > 0 ? Statuses.Pending : Statuses.Enabled })); });
    };
    var ratingPostedSuccessContent = (React.createElement(React.Fragment, null,
        React.createElement("h4", null, translate('collection_rating.modal.global.success.rating.title')),
        React.createElement("div", { className: "flex-center" },
            React.createElement("button", { type: "button", onClick: handleClose, className: "btn" }, translate('collection_rating.modal.global.success.rating.action.close')))));
    var commentPostedSuccessContent = (React.createElement(React.Fragment, null,
        React.createElement("h4", null, translate('collection_rating.modal.global.success.comment.title')),
        React.createElement("p", { className: "subtitle" }, translate('collection_rating.modal.global.success.comment.subtitle')),
        React.createElement("div", { className: "flex-center" },
            React.createElement("button", { type: "button", onClick: handleClose, className: "btn" }, translate('collection_rating.modal.global.success.comment.action.close')))));
    var editContent = (React.createElement(React.Fragment, null,
        React.createElement("h4", null, translate('collection_rating.modal.global.edit.title')),
        React.createElement(StarList, { note: (_b = rating === null || rating === void 0 ? void 0 : rating.note) !== null && _b !== void 0 ? _b : 0, isClickable: true, afterStarNumberChange: handleStarNumberChange }),
        React.createElement(Textarea, { afterCommentChange: handleCommentChange, rating: rating }),
        React.createElement("button", { type: "button", className: "btn", onClick: handleUpdate }, translate('collection_rating.modal.global.edit.action.submit')),
        React.createElement("button", { type: "button", onClick: handleClose, className: "btn-link" }, translate('collection_rating.modal.global.edit.action.cancel'))));
    var deleteContent = (React.createElement("div", { id: "deleteModalContent" },
        React.createElement("h4", { className: "title" }, translate('collection_rating.modal.global.delete.title')),
        React.createElement("button", { type: "button", onClick: handleClose, className: "btn" }, translate('collection_rating.modal.global.delete.action.cancel')),
        React.createElement("button", { type: "button", onClick: handleDelete, className: "btn-link" }, translate('collection_rating.modal.global.delete.action.submit'))));
    var renderContent = function () {
        if (mode === GlobalModalModes.Edit) {
            return editContent;
        }
        if (mode === GlobalModalModes.Delete) {
            return deleteContent;
        }
        if (isCommentPresent) {
            return commentPostedSuccessContent;
        }
        return ratingPostedSuccessContent;
    };
    return (React.createElement("div", { id: "globalModal", ref: modalRef, className: "modal " + (isOpen ? 'modal--open' : ''), role: "dialog", "aria-hidden": "true" },
        React.createElement("i", { className: "iconoir-xmark close-modal", onClick: handleClose }),
        renderContent()));
};
export { GlobalModal };
